import '@babel/polyfill'
import React from 'react'
import { render } from 'react-dom'
import Routes from './routes/Routes'
import './styles/animate.css'
import './index.css'
import './styles/bootstrap/customizations.css'
import GAContextProvider from './contexts/GAContext'

render(
  <GAContextProvider>
    <Routes />
  </GAContextProvider>, document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js